import { useAuthStore } from "@/stores/authStore";
import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    name: "dashboard",
    path: "/",
    component: () => import("@/views/dashboard/Info.vue"),
    meta: {},
  },
  {
    name: "my-tasks",
    path: "/my-tasks",
    component: () => import("@/views/dashboard/MyTasks.vue"),
    meta: {},
  },
  {
    name: "my-tools",
    path: "/my-tools",
    component: () => import("@/views/dashboard/MyTools.vue"),
    meta: {},
  },
  {
    name: "patient-contact",
    path: "/contact",
    component: () => import("@/views/dashboard/Contact.vue"),
    meta: {},
  },

  {
    name: "enroll",
    path: "/enroll",
    component: () => import("@/views/EnrollView.vue"),
    meta: {
      allowAnonymous: true,
      showLayout: false,
    },
  },
  {
    name: "enrolled",
    path: "/enrolled",
    component: () => import("@/views/EnrollSuccessView.vue"),
    meta: {
      allowAnonymous: true,
      showLayout: false,
    },
  },
  {
    name: "interaction-submitted",
    path: "/submitted",
    component: () => import("@/views/SubmitSuccessView.vue"),
    props: (route) => ({ redirectToUrl: route.query.redirectTo }),
    meta: {
      allowAnonymous: true,
      showLayout: false,
    },
  },
  {
    name: "patient-interaction",
    path: "/invites/:requestKey",
    component: () => import("@/views/InteractionView.vue"),
    meta: {
      allowAnonymous: true,
      showLayout: true,
    },
  },
  {
    // MwmEmailService.ConfigureMeetingInformation() links here
    name: "join-meeting",
    path: "/join-meeting/:callbackTaskId",
    component: () => import("@/views/JoinVideo.vue"),
    props: true,
    meta: {
      allowAnonymous: true,
      showLayout: false,
    },
  },
  {
    name: "login",
    path: "/login",
    component: () => import("@/views/auth/Login.vue"),
    meta: {
      allowAnonymous: true,
    },
  },
  {
    name: "logout",
    path: "/logout",
    component: () => import("@/views/auth/Logout.vue"),
    meta: {
      allowAnonymous: true,
    },
  },
  {
    name: "activate-account",
    path: "/activate/:token",
    component: () => import("@/views/auth/ActivateAccount.vue"),
    props: true,
    meta: {
      allowAnonymous: true,
    },
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("@/views/auth/ForgotPassword.vue"),
    meta: {
      allowAnonymous: true,
    },
  },
  {
    name: "reset-password",
    path: "/reset-password/:token",
    component: () => import("@/views/auth/ResetForgotPassword.vue"),
    props: true,
    meta: {
      allowAnonymous: true,
    },
  },
];

// Developer only REST console. The switch is inlined at build time, so with the empty value that
// .env carries the branch folds to a constant false and webpack drops both the route and the chunk
// behind it — a production bundle does not contain the console at all. That only holds while the
// variable is declared in .env: if it is missing entirely webpack cannot fold the check and emits
// the chunk anyway. See views/dev/ApiTestConsole.vue.
if (process.env.VUE_APP_ENABLE_API_TEST_CONSOLE === "true") {
  routes.push({
    name: "api-test-console",
    path: "/test-app",
    component: () =>
      import(
        /* webpackChunkName: "api-test-console" */
        "@/views/dev/ApiTestConsole.vue"
      ),
    meta: {
      // Signing in is one of the things the console is for, so it has to be reachable signed out.
      allowAnonymous: true,
      showLayout: false,
    },
  });
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  await Vue.nextTick();
  const authStore = useAuthStore();
  if (!(to.meta?.allowAnonymous ?? false) && !(await authStore.isLoggedIn())) {
    next({ name: "login" });
    return { name: "login" };
  }
  next();
  return true;
});

export default router;
